export const BASEMAP_STORAGE_KEY = 'rede_schedule_map_basemap';
export const DEFAULT_BASEMAP_ID = 'CartoVoyager';

const CARTO_API_KEY =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CARTO_API_KEY) ||
  'cb1_2qhg_1_4283fd1f4d4be9d66cd33377';

export const BASEMAP_PROVIDERS = [
  {
    id: 'CartoVoyager',
    labelKey: 'SCHEDULE_MAP.BASEMAP.CARTO_VOYAGER',
    isDefault: true,
    url: `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png?key=${CARTO_API_KEY}`,
    subdomains: 'abcd',
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution/" target="_blank">CARTO</a>',
    maxZoom: 20,
  },
  {
    id: 'OpenStreetMap',
    labelKey: 'SCHEDULE_MAP.BASEMAP.OPENSTREETMAP',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    subdomains: 'abc',
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
    maxZoom: 19,
  },
  {
    id: 'Satellite',
    labelKey: 'SCHEDULE_MAP.BASEMAP.SATELLITE',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution:
      'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    maxZoom: 19,
  },
];

export const BASEMAP_PROVIDER_MAP = Object.fromEntries(
  BASEMAP_PROVIDERS.map(provider => [provider.id, provider])
);

export const getBasemapProvider = id => BASEMAP_PROVIDER_MAP[id] || BASEMAP_PROVIDERS[0];

export const getStoredBasemapId = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const stored = window.localStorage.getItem(BASEMAP_STORAGE_KEY);
      if (stored && stored in BASEMAP_PROVIDER_MAP) {
        return stored;
      }
    }
  } catch {
    // localStorage might be unavailable or restricted
  }
  return DEFAULT_BASEMAP_ID;
};

export const setStoredBasemapId = id => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(BASEMAP_STORAGE_KEY, id);
    }
  } catch {
    // localStorage might be unavailable or restricted
  }
};
